import { List } from 'immutable';

import State from './core/State';

const initialState: State = {
  creativePerformanceCreatives: {
    creatives: List(),
    campaigns: List(),
    ads: List(),
    filters: [],
    sort: null,
    fetching: 0,
    appendFetching: 0,
    pageInfo: null,
    perPage: 50,
    currentPage: 0,
  },
  adAnalyticsVideos: {
    items: null,
    dailyPerformances: List(),
    selectedVideos: List(),
    filters: [],
    sort: null,
    fetching: 0,
    appendFetching: 0,
    pageInfo: null,
    perPage: 50,
    currentPage: 0,
    submitReport: false,
  },
  adAnalyticsPlacementTypes: {
    placementTypes: null,
    selectedPlacementTypes: {
      platformKey: [],
      mediaKey: [],
      placementKey: [],
      period: 'lifetime',
    },
    fetching: 0,
  },
  adAnalyticsReport: {
    item: null,
    submitComment: false,
    fetching: 0,
  },
  adAnalyticsReports: {
    items: List(),
    fetching: 0,
  },
  authentication: {
    signedInUser: null,
    fetching: 0,
  },
  availableOrganizations: {
    items: [],
    fetching: 0,
  },
  // createModificationRequest: null,
  postedModificationRequests: {
    modificationRequests: [],
    selectedId: '',
    assets: [],
    fetching: 0,
  },
  modificationRequestEditing: {
    createModificationRequest: {
      id: '',
      bucketId: '',
      items: [],
      assetIds: [],
      uploadingAssetFiles: [],
      uploadingFilesProgress: {},
      feeType: 'no_fee',
      deliveryDue: undefined,
    },
    editModificationRequestItem: {
      item: null,
      uploadingAssetFiles: [],
      uploadingFilesProgress: {},
      uploadedAssetFileIds: [],
    },
    createIssues: [],
    createIssueComments: [],
  },
  creation: {
    creation: null,
    fetching: 0,
  },
  creationSet: {
    creationSet: null,
    fetching: 0,
  },
  facebookAccessToken: '',
  facebookAdAccounts: List(),
  integratedFacebookAdAccounts: {
    adAccounts: List(),
    fetching: 0,
  },
  integratedGoogleAdAccounts: {
    adAccounts: List(),
    fetching: 0,
  },
  googleAdAccounts: List(),
  youtubeChannels: List(),
  amazonAdAccounts: List(),
  yahooAdAccounts: List(),
  tiktokAdAccounts: [],
  integratedAmazonAdAccounts: {
    adAccounts: List(),
    tokenId: '',
    fetching: 0,
  },
  integratedYahooAdAccounts: {
    adAccounts: List(),
    tokenId: '',
    fetching: 0,
  },
  integratedTiktokAdAccounts: {
    adAccounts: [],
    tokenId: '',
    fetching: 0,
  },
  amazonUploadedCreative: false,
  yahooUploadedCreative: false,
  tiktokUploadedCreative: false,
  creativeSending: {
    uploadedAdPlatformKeys: new Map(),
  },
  fatalError: null,
  fullScreenSpinner: {
    necessity: 0,
    loadingMessage: '',
  },
  lastAccessedOrganization: null,
  language: 'ja-JP',
  location: {
    pathname: '/',
    search: '',
  },
  nonFatalErrors: List(),
  project: {
    project: null,
    assetFiles: [],
    briefFiles: new Map(),
    projectFetching: 0,
    filesFetching: 0,
    hasLocalData: false,
  },
  projectChange: {
    projectChange: null,
    latestBriefFiles: new Map(),
    beforeBriefFiles: new Map(),
    fetching: 0,
  },
  projectReporting: {
    performanceReports: new Map(),
  },
  projectEditing: {
    projectType: null,
    isRemovedLocalData: false,
    isAssetTermAgreed: false,
    discountCode: null,
  },
  pricingMerchandiseOptions: {
    availablePricingMerchandiseOptions: [],
    selectedPricingMerchandiseOptions: [],
    fetching: 0,
  },
  projects: {
    draft: {
      items: [],
      pageInfo: null,
      fetching: 0,
    },
    notDraft: {
      items: [],
      hasDraftItems: [],
      pageInfo: null,
      fetching: 0,
    },
    finalized: {
      items: [],
      hasDraftItems: List(),
      pageInfo: null,
      fetching: 0,
    },
  },
  projectTypes: {
    projectTypes: [],
    projectTypesFetching: 0,
  },
  region: 'jp',
  snackbar: {
    message: null,
    messageValues: {},
    action: null,
    actionValues: {},
    isRaw: false,
    onClickAction: null,
    isAutoHide: true,
  },
  translations: {},
  adSearch: {
    isLoading: false,
    isLoaded: false,
    data: null,
    error: null,
    selectedVideos: [],
  },
  acct: {
    productPricing: null,
  },
  latestProjects: {
    items: [],
    hasDraftItems: [],
    pageInfo: null,
    fetching: 0,
  },

  isOpenDesignInspirationScreen: false,
};

export default initialState;
